import Grid2 from '@mui/material/Unstable_Grid2';
import type { ReactNode } from 'react';

import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import {
  SpacingContainer,
  type SpacingContainerProps,
} from '@/components/SpacingContainer/SpacingContainer';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './ProductPageBase.styles';

interface ProductPageBaseProps {
  isBattery?: boolean;
  heading: string;
  subheading: string;
  imageContent: ReactNode;
  description?: string;
  descriptionHtml?: string;
  optionCardLists: ReactNode[];
  totalPrice?: string;
  checkoutButtons: ReactNode[];
  disclaimer?: string;
  className?: string;
}

const ProductPageBase: React.FC<ProductPageBaseProps> = ({
  isBattery = false,
  heading,
  subheading,
  imageContent,
  description,
  descriptionHtml,
  optionCardLists,
  totalPrice,
  checkoutButtons,
  disclaimer,
  className,
}) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  const spacingContainerProps: SpacingContainerProps = isBattery
    ? { spacingLevelOverride: 4 }
    : { isFeatured: true };

  return (
    <SpacingContainer
      {...spacingContainerProps}
      className={cx(classes.container, className)}
    >
      <GridContainer2 fixed>
        <Grid2 xs={12}>
          <h2 className={globalClasses.h2}>{heading}</h2>
          <h3 className={cx(globalClasses.h4, classes.subheading)}>
            {subheading}
          </h3>
        </Grid2>
        <Grid2 xs={12} className={classes.body}>
          <div className={classes.carouselContainer}>{imageContent}</div>
          <div className={classes.productInformationContainer}>
            {description && <p className={globalClasses.body}>{description}</p>}
            {descriptionHtml && (
              <div
                className={globalClasses.body}
                // biome-ignore lint/security/noDangerouslySetInnerHtml: Shopify is a trusted source
                dangerouslySetInnerHTML={{ __html: descriptionHtml }}
              />
            )}
            {optionCardLists}
            {totalPrice && <p className={globalClasses.h3}>{totalPrice}</p>}
            <div className={classes.checkoutButtons}>{checkoutButtons}</div>
            {disclaimer && <p className={classes.disclaimer}>{disclaimer}</p>}
          </div>
        </Grid2>
      </GridContainer2>
    </SpacingContainer>
  );
};

export default ProductPageBase;
